import React, { Fragment, Component } from 'react';
import { AUTH_CONFIG } from '../../../../Auth/auth0-variables';
import axios from 'axios';
import { connect } from 'react-redux'
import { IconButton, ActivityItem, mergeStyleSets, Persona,PersonaSize, Announced } from '@fluentui/react';
import Chats from './Chats';
import Chat from './Chat';
import ChatDetails from './ChatDetails'
import { motion, AnimatePresence } from "framer-motion";
import CreateChat from './CreateChat';
import CreateAnnouncement from './CreateAnnouncement'
import Announcement from './Announcement'
import { closeChat, chatUserId } from '../../../../actions'
import AnnouncementDetails from './AnnouncementDetails';

const variants = {
    enter: (direction) => {
        return {
            x: direction > 0 ? 1000 : -1000,
            opacity: 0,
            height:'100%'
        };
    },
    center: {
        zIndex: 1,
        x: 0,
        opacity: 1,
    },
    exit: (direction) => {
        return {
            zIndex: 0,
            x: direction < 0 ? 1000 : -1000,
            opacity: 0,
            height: '100%'
        };
    }
};
const classNames = mergeStyleSets({
    exampleRoot: {
        marginTop: '0px',
    },
    nameText: {
        fontWeight: '500',
    },
});

class ChatBot extends Component {
    constructor(props) {
        super(props);
        this.state = {
            direction: 0,
            step: 1,
            theme: this.props.theme,
            create: false,
            headerKey: undefined,
            chatUserId: this.props.chatUserId,
            persona: {
                key: 2,
                isCompact: true,
                comments: 'Offline',
                activityDescription: [<span  key={1} className={classNames.nameText}>Javiera Márquez</span>],
                activityPersonas: [{ coinSize: 20, imageInitials: 'JM', text: 'Javiera Márquez' }, { coinSize: 20, imageUrl: "https://static2.sharepointonline.com/files/fabric/office-ui-fabric-react-assets/persona-male.png" }],
            },
        };
    }

    getChat = () => {
        debugger;
        axios.get(AUTH_CONFIG.API_URL + "/api/Schedules/GetChatByUserId?facilityId=" + this.props.facilityId + "&id=" + this.state.chatUserId)
            .then((response) => {
                debugger;
                this.setStep(2, 1, response.data.chatID, response.data);
            });
    }

    componentDidMount() {
        if (this.state.chatUserId) {
            this.getChat()
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.chatUserId !== this.props.chatUserId) {
            this.setState({
                chatUserId: nextProps.chatUserId
            }, () => {
                this.getChat()
            });
        }
        if (nextProps.theme !== this.props.theme) {
            this.setState({
                theme: nextProps.theme
            });
        }
    }


    setStep = (step, direction, id, item) => {
        
        if (item) {
            item.isCompact = true;
            item.activityPersonas && item.activityPersonas.forEach((element, index) => {
                element.imageInitials = element.imageInitials.replace(/\s/g, '').substring(0, 1);
                element.coinSize = 20;
            });
        }
        this.setState({
            step: step,
            direction: direction,
            id: id,
            item: item
        })
    }

    setStepCreateAnnouncement = () => {
        this.setState({
            step: 1,
            direction: -1,
            headerKey: "Announcements"
        })
    }

    setChatDetails = (chat) => {
        this.setState({
            step: 1,
            direction: -1,
            headerKey: "Announcements"
        })
    }

    render() {
        return (
            <div className="chat-container" style={{ backgroundColor: this.state.theme === 'dark' ? '#2e323a' : '#fff'} }>
                <div className="displayflex flex1 spacebetween drag-handle pr10 pl10 header">
                    <div className="displayflex aligncenter ">
                       
                        {this.state.step == 1 &&
                            <div className="chat-location-avatar displayflex aligncenter">
                            <Persona
                                    imageInitials={this.props.user.firstName.charAt(0) +this.props.user.lastName.charAt(0)}
                                    imageUrl={process.env.REACT_APP_CDN_URL + this.props.user.userImg}
                                    initialsColor={this.props.user.avatarColor}
                                    size={PersonaSize.size32}
                                />
                                <h3 className="head-s ml10">Chats</h3>
                        </div>
                        }
                        {this.state.step == 2 &&
                            <Fragment>
                                <IconButton
                                styles={{
                                    root: {
                                        color: "black",
                                        marginLeft: 'auto',
                                        marginRight: '2px',
                                    },
                                    icon: { fontSize: 16, color: '#fff !important' },
                                    rootHovered: {
                                        color: "black",
                                        backgroundColor: 'transparent'
                                    },
                                    rootPressed: {
                                        color: "black",
                                        backgroundColor: 'transparent'
                                    },
                                }}
                                iconProps={{ iconName: 'Back' }}
                                onClick={() => this.setStep(1, -1)}
                            />
                            <div style={{width:230}}>
                                <ActivityItem {...this.state.item} className={classNames.exampleRoot} />
                            </div>
                            
                             </Fragment>
                        }
                        {this.state.step == 3 &&
                            <Fragment>
                                <IconButton
                                    styles={{
                                        root: {
                                            color: "black",
                                            marginLeft: 'auto',
                                            marginRight: '2px',
                                        },
                                        icon: { fontSize: 16, color: '#fff !important' },
                                        rootHovered: {
                                            color: "black",
                                            backgroundColor: 'transparent'
                                        },
                                        rootPressed: {
                                            color: "black",
                                            backgroundColor: 'transparent'
                                        },
                                    }}
                                    iconProps={{ iconName: 'Back' }}
                                    onClick={() => this.setStep(1, -1)}
                                />
                            <h3 className="head-s">Create</h3>
                            </Fragment>
                        }
                        {this.state.step == 6 &&
                            <Fragment>
                                <IconButton
                                    styles={{
                                        root: {
                                            color: "black",
                                            marginLeft: 'auto',
                                            marginRight: '2px',
                                        },
                                        icon: { fontSize: 16, color: '#fff !important' },
                                        rootHovered: {
                                            color: "black",
                                            backgroundColor: 'transparent'
                                        },
                                        rootPressed: {
                                            color: "black",
                                            backgroundColor: 'transparent'
                                        },
                                    }}
                                    iconProps={{ iconName: 'Back' }}
                                onClick={() => this.setStep(2, -1, this.state.id, this.state.item)}
                                />
                                <h3 className="head-s">Chat Info</h3>
                            </Fragment>
                        }
                        {this.state.step == 7 &&
                            <Fragment>
                                <IconButton
                                    styles={{
                                        root: {
                                            color: "black",
                                            marginLeft: 'auto',
                                            marginRight: '2px',
                                        },
                                        icon: { fontSize: 16, color: '#fff !important' },
                                        rootHovered: {
                                            color: "black",
                                            backgroundColor: 'transparent'
                                        },
                                        rootPressed: {
                                            color: "black",
                                            backgroundColor: 'transparent'
                                        },
                                    }}
                                    iconProps={{ iconName: 'Back' }}
                                onClick={() => this.setStep(5, -1, this.state.id, this.state.item)}
                                />
                                <h3 className="head-s">Announcement Info</h3>
                            </Fragment>
                        }
                        {(this.state.step == 4 || this.state.step == 5) &&
                            <Fragment>
                                <IconButton
                                    styles={{
                                        root: {
                                            color: "black",
                                            marginLeft: 'auto',
                                            marginRight: '2px',
                                        },
                                        icon: { fontSize: 16, color: '#fff !important' },
                                        rootHovered: {
                                            color: "black",
                                            backgroundColor: 'transparent'
                                        },
                                        rootPressed: {
                                            color: "black",
                                            backgroundColor: 'transparent'
                                        },
                                    }}
                                    iconProps={{ iconName: 'Back' }}
                                onClick={() => this.setStepCreateAnnouncement()}
                                />
                                <h3 className="head-s">Announcement</h3>
                            </Fragment>
                        }
                    </div>
                    <div className="displayflex">
                        {this.state.step == 2 &&
                            <IconButton
                                styles={{
                                    root: {
                                        color: "black",
                                        marginLeft: 'auto',
                                        marginRight: '2px',
                                    },
                                    icon: { fontSize: 18, color: '#fff !important' },
                                    rootHovered: {
                                        color: "black",
                                        backgroundColor: 'transparent'
                                    },
                                    rootPressed: {
                                        color: "black",
                                        backgroundColor: 'transparent'
                                    },
                                }}
                                iconProps={{ iconName: 'Info' }}
                            onClick={() => this.setStep(6, 1, this.state.id, this.state.item)}
                            />
                        }
                        <IconButton
                            className="hide-on-mobile"
                            styles={{
                                root: {
                                    color: "black",
                                    marginLeft: 'auto',
                                    marginRight: '2px',
                                },
                                icon: { fontSize: 12, color: '#fff !important' },
                                rootHovered: {
                                    color: "black",
                                    backgroundColor: 'transparent'
                                },
                                rootPressed: {
                                    color: "black",
                                    backgroundColor: 'transparent'
                                },
                            }}
                            iconProps={{ iconName: 'ChromeClose' }}
                            onClick={() => this.props.dispatch(closeChat(true))}
                        />
                    </div>
                </div>
                <div className="" style={{ overflow: 'hidden', position: 'relative', height:'calc(100% - 40px)'}}>
                    <AnimatePresence initial={false} custom={this.state.direction}>
                        <motion.div
                            key={this.state.step}
                            custom={this.state.direction}
                            variants={variants}
                            initial="enter"
                            animate="center"
                            exit="exit"
                            transition={{
                                x: { type: "tween", stiffness: 300, damping: 30, bounce: 0 },
                                opacity: { duration: 0.2 }
                            }}
                        >
                            {this.state.step == 1 &&
                                <Chats callback={this.setStep} bot={true} headerKey={this.state.headerKey}/>
                            }
                            {this.state.step == 2 &&
                                <Chat chatId={this.state.id} page={"c"} item={this.state.item} />
                            }
                            {this.state.step == 3 &&
                                <CreateChat callback={this.setStep} addPadding={ true } />
                            }
                            {this.state.step == 4 &&
                                <CreateAnnouncement callback={this.setStepCreateAnnouncement} />
                            }
                            {this.state.step == 5 &&
                                <Announcement item={this.state.item} callback={this.setStep}/>
                            }
                            {this.state.step == 6 &&
                                <ChatDetails chatId={this.state.id} bot={true} />
                            }
                            {this.state.step == 7 &&
                                <AnnouncementDetails id={this.state.item.announcementId} bot={true} />
                            }
                        </motion.div>
                    </AnimatePresence>
                    
                    
                </div>
                
            </div>
        );
    }
}

function mapStateToProps(state) {
    const user = state.userProfile;
    const facilityId = state.appState.product.facility.facilityID;
    const theme = state.rootReducer.theme;

    return {
        user,
        facilityId,
        theme
    }
}

export default connect(mapStateToProps)(ChatBot);

